import { gql } from "@apollo/client";

export function prepareQueryForBookmarks(
  stockpiles: string[],
  sensorId: string
) {
  let bookmarksData: string = "";

  for (let i = 0; i < stockpiles.length; i++) {
    bookmarksData += `${stockpiles[i].replace(
      / /,
      ""
    )}: getBookmarks(stockpiles: ["${
      stockpiles[i]
    }"], sensorId: "${sensorId}") {
      stockpileId
      requestId
      sensorId
      text
      title
      x
      id
    }
    `;
  }

  return gql`
    query @api(name: "cosmos") {
      ${bookmarksData}
    }
  `;
}

export function prepareQueryForExportBookmarks(
  stockpiles: string[],
  sensorIds: string[]
) {
  let bookmarksData: string = "";

  for (let i = 0; i < sensorIds.length; i++) {
    bookmarksData += `${sensorIds[i]}: getBookmarks(stockpiles: [${stockpiles
      .map((sp) => `\"${sp}\"`)
      .toString()}], sensorId: "${sensorIds[i]}") {
      stockpileId
      requestId
      sensorId
      text
      title
      x
      id
    }
    `;
  }

  return gql`
    query @api(name: "cosmos") {
      ${bookmarksData}
    }
  `;
}
